/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const JIRA_ISSUE_UPDATED_SUBSCRIPTION = gql`
    subscription ($clientKey: String!) {
        jiraIssueUpdated(clientKey: $clientKey) {
            id
            self
            key
            summary
        }
    }
`;

export const COMPONENTS_IMPORT_PROGRESS = gql`
    subscription {
        componentsImportProgress {
            percent
        }
    }
`;

export const COMPONENTS_SYNC_STARTED = gql`
    subscription {
        componentsSyncStarted
    }
`;

export const COMPONENTS_SYNC_FINISHED = gql`
    subscription {
        componentsSyncFinished
    }
`;

export const COMPONENTS_SYNC_IN_PROGRESS = gql`
    subscription {
        componentsSyncInProgress
    }
`;
